
import { Button } from "@/components/ui/button";
import { PlusCircle, Aperture } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface LensEmptyStateProps {
  searchQuery: string;
  onAddLensClick: () => void;
}

export function LensEmptyState({ searchQuery, onAddLensClick }: LensEmptyStateProps) {
  const { t } = useTranslation();
  
  return (
    <div className="text-center p-8 border rounded-lg bg-muted/10">
      {searchQuery ? (
        <p className="text-muted-foreground">{t('no_lenses_found')} "{searchQuery}"</p>
      ) : (
        <div className="space-y-4 flex flex-col items-center">
          <Aperture className="h-16 w-16 text-muted-foreground opacity-20" />
          <div>
            <p className="text-muted-foreground mb-2">{t('no_lenses_yet')}</p>
            <Button variant="outline" onClick={onAddLensClick}>
              <PlusCircle className="h-4 w-4 mr-1" />
              {t('add_first_lens')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
